import { useMemo, useState } from 'react'
import Label from '../../../ui/Label'
import DropdownBtn from '../../../ui/DropdownBtn'
import Loading from '../../../ui/Loading'
import ErrorMessage from '../../../ui/ErrorMessage'
import { useDispatch, useSelector } from 'react-redux'
import { selectNewProductType, updateNewProduct } from '../../../../features/product/productSlice'
// import { ProductTemperature } from '../../../../types/product'
import { useMasterData } from '../../../../hooks/api/useMasterData'
import { TemperatureResponseData } from '../../../../features/setup/setupResponse'

export default function ProdModTemperature() {

    const dispatch = useDispatch()
    const { 
        productTemperature,
        isLoadingProductTemperature,
        isErrorProductTemperature,
        errorMessageProductTemperature,
    } = useMasterData()
    const [isOpenDropdownTemperature, setIsOpenDropdownTemperature] = useState<boolean>(false)
    const selectNewProductFormType = useSelector(selectNewProductType)
    
    const activeProductTemperature = useMemo(() => {
        return productTemperature.filter(
            (opt: TemperatureResponseData) => opt.isActive
        );
    }, [productTemperature]);

    return (
        <div className=''>
            <Label label={'Temperature *'}/>
            <div className='relative inline-block h-auto w-full'>
                <div className='w-full h-auto'>
                    <DropdownBtn
                        label={selectNewProductFormType?.label || 'Select Temperature'}
                        isOpen={isOpenDropdownTemperature}
                        setIsOpenStatus={setIsOpenDropdownTemperature}
                        isCustomClass={true}
                        customClass={'flex w-full justify-between items-center rounded transition px-2  text-black py-1.5 space-x-2 text-xs  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black'}
                    />
                    {isOpenDropdownTemperature && (
                        <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
                            { isLoadingProductTemperature ? (
                                <li className='px-3 py-1.5 hover:bg-gray-100 cursor-pointer text-xs w-full'>
                                    <Loading setH={'h-[20px]'}/>
                                </li>
                            ) : isErrorProductTemperature ? (
                                <li className='px-3 py-1.5 hover:bg-gray-100 cursor-pointer text-xs w-full'>
                                    <ErrorMessage message={errorMessageProductTemperature} setH={'h-[20px]'}/>
                                </li> 
                            ) : (
                                activeProductTemperature.map((opt: TemperatureResponseData) => (
                                    <li
                                        key={opt.typeId}
                                        onClick={() => {
                                            setIsOpenDropdownTemperature(false)
                                            dispatch(updateNewProduct({ type: {
                                                id: opt.typeId,
                                                label: opt.typeName
                                            } }))
                                        }}
                                        className='px-3 py-1.5 hover:bg-gray-100 cursor-pointer text-xs w-full'
                                    >
                                        {opt.typeName}
                                    </li>
                                ))
                            )}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    )
}
